// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../index';

import { gql } from 'graphql-tag';
import { BlockFragmentDoc } from '../../../../components/cms/CmsBlock.fragment.generated';
export const ProductPageFacetedContentLongDescriptionFragmentDoc = gql`
    fragment productPageFacetedContentLongDescription on ProductPageFacetedContentLongDescription {
  ... on ProductPageFacetedContentLongDescriptionBlock {
    blocks {
      ...block
    }
  }
  ... on ProductPageFacetedContentLongDescriptionText {
    text
  }
}
    ${BlockFragmentDoc}`;